/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { Breadcrumb } from "components/atoms/Breadcrumb";
import { TermSidebar } from "features/terms/TermSidebar";
import React from "react";
import { SubContentsLayout } from "ui/SubContentsLayout";

export const FanclubTermsOfService: React.FC = () => {
  const classes = styles();

  return (
    <SubContentsLayout>
      <Breadcrumb
        // @ts-expect-error TS2322
        paths={[
          // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
          ["/", "ホーム"],
          // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
          [null, "ファンクラブ運営サービス利用規約"],
        ]}
      />

      <div css={classes.root}>
        {/* サイドバーを表示する */}
        <TermSidebar />

        {/* コンテンツを表示する */}
        <div css={classes.main}>
          <iframe
            // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
            title="ファンクラブ運営サービス利用規約"
            src="https://docs.google.com/document/d/e/2PACX-1vSUKy0uzmvCxYWReC9OytQfqQl6Zl_zqgTgPDk5cNtj2d8V_OXtqrnpnv0GiI7-jg/pub?embedded=true"
          ></iframe>
        </div>
      </div>
    </SubContentsLayout>
  );
};

const styles = () => {
  return {
    root: css`
      display: grid;
      grid-template-columns: 100%;
      grid-gap: 16px;
      width: 90%;
      max-width: 1140px;
      padding: 80px 0;
      margin: 0 auto;
      @media screen and (min-width: 768px) {
        grid-template-columns: 320px auto;
      }
    `,
    main: css`
      position: relative;
      width: 100%;
      iframe {
        width: 100%;
        height: 4500px;
      }
    `,
  };
};
